<div>
    <div *ngIf="occasions.Value().length > 0" class="ui stackable three column grid">
        <occasions-light *ngFor="let occasion of occasions.Value()" [occasion]="occasion" class="column"></occasions-light>
    </div>
    <div *ngIf="occasions.Value().length == 0" class="ui stackable three column grid">
        <h3 class="no-occasion">Aucune occasion correspondant à vos critères de recherches</h3>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/occasions/content/occasions-list/occasions-list.html